import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ArticleService } from "../article/article.service";
import { Article } from "../article/article";
import { environment } from "../../environments/environment";
import { UserService } from "../user/user.service";
import { Alert } from "../alert/alert";
import { Subscription } from 'rxjs/Subscription';
import { FilterService } from "../filter/filter.service";
import { Filter } from "../filter/filter";

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit {

  public articles:Article[];
  public imgUrl:String = environment.urls.img;

  public alert:Alert = new Alert('hide', '', '');

  public filter:Filter;
  private filterSubscription:Subscription;

  constructor(private articleService:ArticleService,
              public router:Router,
              public route:ActivatedRoute,
              private userService:UserService,
              private filterService:FilterService) {
  }

  ngOnInit() {

    this.articleService.getAllArticles().subscribe(
      articles => this.articles = articles,
      error => {
        this.alert = new Alert("show", "alert-danger", error);
        setTimeout(() => this.alert.state = "hide", 4000);
      });

    if (Object.keys(this.route.snapshot.params).length != 0) {
      this.alert = new Alert(this.route.snapshot.params['state'], this.route.snapshot.params['level'], this.route.snapshot.params['message']);
      setTimeout(() => this.alert.state = "hide", 4000);
    }

    this.filterSubscription = this.filterService.filter$.subscribe(filter => this.filter = filter);
  }

  public displayDetails(isbn):void {
    this.userService.checkSession().subscribe(
      suc => this.router.navigate(['details', isbn]),
      err => this.router.navigate(['login'])
    );
  }

  public addNewArticle():void {
    this.userService.checkSession().subscribe(
      suc => this.router.navigate(['add-article']),
      err => this.router.navigate(['login'])
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/overview/overview.component.ts